import React from 'react';

/* Конвертирует URL Яндекс map-widget в эквивалент Google Maps (keyless embed,
   без API-ключа). Используется для пользователей Беларуси/Казахстана. */
function yandexToGoogle(src) {
  try {
    const u = new URL(src);
    const q = u.searchParams;
    const z = q.get('z') || '15';
    const g = (query, zoom = z) =>
      `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=${zoom}&hl=ru&output=embed`;
    const gLatLon = (lat, lon, zoom = z) =>
      `https://maps.google.com/maps?q=${lat},${lon}&z=${zoom}&hl=ru&output=embed`;

    /* ?rtext=A~B~C — несколько точек → directions-эмбед (все точки как
       остановки маршрута, у каждой пин); без API-ключа. */
    const rtext = q.get('rtext');
    if (rtext) {
      const stops = rtext.split('~').map(s => s.trim()).filter(Boolean);
      if (stops.length > 1) {
        const saddr = encodeURIComponent(stops[0]);
        const daddr = stops.slice(1).map(encodeURIComponent).join('+to:');
        return `https://maps.google.com/maps?saddr=${saddr}&daddr=${daddr}&hl=ru&output=embed`;
      }
      if (stops.length === 1) return g(stops[0]);
    }
    // ?text= / ?mode=search&text= — поиск по адресу (одна точка)
    const text = q.get('text');
    if (text) return g(text);
    // ?ll=LON,LAT (порядок Яндекса lon,lat) — центр
    const ll = q.get('ll');
    if (ll) { const [lon, lat] = ll.split(',').map(s => s.trim()); return gLatLon(lat, lon); }
    // ?pt=LON,LAT[,style] — точка
    const pt = q.get('pt');
    if (pt) { const [lon, lat] = pt.split(',').map(s => s.trim()); return gLatLon(lat, lon); }
    return `https://maps.google.com/maps?z=${z}&output=embed`;
  } catch (_) {
    return src;
  }
}

/* Обёртка над <iframe> карты.
   provider ('yandex' | 'google') — явный выбор картографа в блоке «Локация».
   Если задан — имеет приоритет над регионом. Если не задан (пусто/undefined) —
   по умолчанию: by/kz → Google, ru → Яндекс (обратная совместимость).
   Остальные пропсы (style, allowFullScreen, allow, title, loading…)
   пробрасываются в iframe. */
export default function MapFrame({ region = 'ru', provider, src, ...rest }) {
  const useGoogle = provider
    ? provider === 'google'
    : (region === 'by' || region === 'kz');
  const finalSrc = useGoogle ? yandexToGoogle(src) : src;
  return <iframe src={finalSrc} {...rest} />;
}
